import { compKey } from './key';
import { createTextAreaDriver, createButtonDriver } from '@wix/answers-ui-libby';
export var createCsatSurveyViewDriver = function (wrapper) {
    var base = wrapper.$("." + compKey);
    var submitButtonWrapper = base.$('.submit-button-wrapper');
    return {
        ratingRequestMessage: base.$('.survey-title').text,
        followUpMessage: base.$('.user-comment-follow-up-message').text,
        isFollowUpMessageVisible: base.$('.user-comment-follow-up-message').exists,
        isResponseMessageVisible: base.$('.user-comment-response-message').exists,
        responseMessage: base.$('.user-comment-response-message').text,
        customerCommentEnabled: base.$('.user-comment-wrapper').exists,
        userComment: createTextAreaDriver(base.$('.user-comment-wrapper')).value,
        changeUserComment: function (comment) {
            return createTextAreaDriver(base.$('.user-comment-wrapper')).set(comment);
        },
        userCommentLengthCounter: base.$('.comment-length-counter').text,
        isSubmitButtonVisible: submitButtonWrapper.exists,
        submit: createButtonDriver(submitButtonWrapper).click,
        selectSatisfactionOption: function (option) {
            return base.$(".satisfaction-option.satisfaction-" + option).click();
        },
        isSatisfactionSelected: function (option) {
            return base.$(".satisfaction-option.satisfaction-" + option).hasClass('selected');
        },
        base: base
    };
};
//# sourceMappingURL=driver.js.map